<template>
  <div v-if="data" class="d-flex align-center" style="min-height: 20px">
    <!-- icon -->
    <DataIcon v-if="showIcon"
      :data="data"
      :iconWidth="iconWidth"
      :iconHeight="iconHeight"
      :showFavorite="true"
      :favorite="data?.favorite"
      :style="{marginRight: iconMarginRight}"
    />
    <!-- 이름 (일반 모드) -->
    <div v-if="!isModifyingName" :style="showIcon ? {width: `calc(100% - ${iconWidth} - ${iconMarginRight})`} : {width: `calc(100%)`}">
      <v-hover v-slot="{ hover }">
        <div class="d-flex align-center">
          <div v-ellipsis-tooltip
            :class="`data-name-${data?.id}`" 
            style="max-width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; color: #0D0E17"
            :style="{fontSize: nameFontSize, fontWeight: nameFontWeight, lineHeight: nameLineHeight}"
          >
            {{ data?.name }}
          </div>
          <!-- 수정 버튼 -->
          <v-tooltip v-if="hover && canEdit" bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on" class="d-flex align-center ml-1" style="width: 20px; height: 20px">
                <div @click.stop="clickModifyNameBtn()"
                  class="d-flex align-center justify-center"
                  :class="$store.getters.permissionLevel < 1 ? 'disabled-icon-btn' : 'default-icon-btn'"
                  style="width: 18px; height: 18px"
                >
                  <v-icon style="font-size: 15px">mdi-pencil</v-icon>
                </div>
              </div>
            </template>
            <span>{{ $store.getters.permissionLevel >= 1 ? '수정' : '수정 권한이 없습니다.' }}</span>
          </v-tooltip>
        </div>
      </v-hover>
    </div>
    <!-- 이름 (수정 모드) -->
    <div v-else class="d-flex align-center" style="width: 100%" v-click-outside="cancelModifyName">
      <!-- 수정창 -->
      <v-text-field @click.stop="clickStop()"
        v-model="data.name" @keyup.enter="modifyName(data)" @keyup.esc="cancelModifyName()" :style="{fontSize: nameFontSize}"
        class="modify-text-input mt-0 pt-0" style="width: 100%" hide-details autofocus color="#0D0E17"
      ></v-text-field>
      <!-- 확정 버튼 -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on" @click.stop="modifyName(data)"
            class="d-flex align-center justify-center ml-1"
            :class="!data?.name.trim() ? 'disabled-icon-btn' : 'default-icon-btn'"
            style="min-width: 18px; max-width: 18px; height: 18px"
          >
            <v-icon style="font-size: 15px">mdi-check</v-icon>
          </div>
        </template>
        <span>확인</span>
      </v-tooltip>
      <!-- 취소 버튼 -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on" @click.stop="cancelModifyName()"
            class="default-icon-btn d-flex align-center justify-center ml-1"
            style="min-width: 18px; max-width: 18px; height: 18px"
          >
            <v-icon style="font-size: 15px">mdi-close</v-icon>
          </div>
        </template>
        <span>취소</span>
      </v-tooltip>
    </div>
    <!-- Join > Left, Right 표시 -->
    <div v-if="joinIdx !== null && joinIdx !== undefined" style="padding-left: 8px">
      <div class="d-flex align-center" style="height: 24px; border-radius: 12px; background-color: #EFF0F6; padding: 0px 10px">
        <div style="word-break: keep-all; font-size: 13px; font-weight: 600; line-height: 16px; color: #8A8DA8">
          {{ joinIdx ? 'Right' : 'Left' }}
        </div>
      </div>
    </div>
    <!-- Text Match > 대상, 기준 표시 -->
    <div v-if="textMatchIdx !== null && textMatchIdx !== undefined" style="padding-left: 8px">
      <div class="d-flex align-center" style="height: 24px; border-radius: 12px; background-color: #EFF0F6; padding: 0px 10px">
        <div style="word-break: keep-all; font-size: 13px; font-weight: 600; line-height: 16px; color: #8A8DA8">
          {{ textMatchIdx ? '기준' : '대상' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http-common"

export default {
  name: "DataName",

  components: {
  },

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    iconWidth: {
      type: String,
      default: '26px'
    },
    iconHeight: {
      type: String,
      default: '26px'
    },
    iconMarginRight: {
      type: String,
      default: '12px'
    },
    nameFontSize: {
      type: String,
      default: '16px'
    },
    nameFontWeight: {
      type: String,
      default: '400'
    },
    nameLineHeight: {
      type: String,
      default: '20px'
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    joinIdx: {
      type: Number,
      default: null
    },
    textMatchIdx: {
      type: Number,
      default: null
    },
  },

  data() {
    return {
      isModifyingName: false,
      originName: this.data?.name,
    }
  },

  methods: {
    clickModifyNameBtn() {
      console.log('clickModifyNameBtn')
      this.isModifyingName = true
      this.originName = this.data?.name
    },
    modifyName(data) {
      console.log('modifyName', data)
      if (!data) {
        console.log('data is null')
        return false
      }
      if (!data?.name || !data?.name.trim()) {
        console.log('name is empty')
        return false
      }
      if (data?.name.length >= 200) {
        this.$store.commit('swalToast', {title: '200자까지만 입력이 가능합니다.', type: 'warning'})
        return false
      }
      let form = new FormData()
      form.append('name', data?.name ? data.name.normalize('NFC') : data?.name)
      http
      .put(`annotation/multi-table-data/${data.id}/`, form, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
      .then(res => {
        console.log('modifyName res', res)
        this.$store.commit('setOverlay', false)
        this.$store.commit('setOverlayText', '')
        this.$store.commit('swalToast', {title: '수정되었습니다.', type: 'success'})
        this.$emit('setCurrentDataName', res.data)
        this.isModifyingName = false
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        if (err.response && err.response.status === 401) { // access token 만료
          this.methodRecall()
          .then(msg => {
            console.log(msg)
            this.modifyName(data) // method 재호출
          })
          .catch(err_msg => {
            console.log(err_msg)
            this.$store.commit('setOverlay', false)
            this.$store.commit('setOverlayText', '')
            if (err_msg === 0) {
              console.log('BE에 access token 저장 실패')
            } else { // err_msg === 1
              console.log('refresh token 만료(access token 갱신 실패)')
              // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
              this.$store.commit('logout')
              this.$router.push('/').catch(() => {})
            }
          })
        }
      })
    },
    cancelModifyName() {
      console.log('cancelModifyName')
      this.data.name = this.originName
      this.isModifyingName = false
    },
  },

  mounted() {
    // console.log('DataName mounted')
    // console.log('data', this.data)
  },

  watch: {
    isModifyingName(isModifyingName) {
      console.log('watch isModifyingName', isModifyingName)
      this.$emit('setIsModifyingName', isModifyingName)
    },
  }
}
</script>

<style scoped>
.modify-text-input >>> .v-input__control .v-input__slot {
  min-height: 21px !important;
  height: 21px !important;
}
.modify-text-input >>> .v-input__control .v-input__slot .v-text-field__slot input {
  padding: 0px 0px 1px 0px !important;
}
</style>